import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useLocationQuery from '../../hooks/useQuery';
import {
  getDashboardReportPharmacies,
  getDashboardReportPharmaciesReset,
} from '../../redux/dashboard-reports';
import ReportsTable from './reports-components/ReportsTable'

const LiveReportsPage = () => {
  const dispatch = useDispatch();

  const { query } = useLocationQuery();

  useEffect(() => {
    dispatch(getDashboardReportPharmaciesReset());
    dispatch(getDashboardReportPharmacies(query));
  }, [query, dispatch]);

  return (
    <>
      <ReportsTable />
    </>
  );
};

export default LiveReportsPage;
